import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { CookieConsentService } from './cookie-consent.service';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  constructor(
    private router: Router,
    private cookieConsent: CookieConsentService,
  ) {}

  // El snippet de gtag.js (script + dataLayer + consent default) está fijo
  // en index.html para que Google Tag Manager detecte la etiqueta siempre,
  // incluso sin ejecutar JavaScript. Aquí solo actualizamos el consentimiento
  // real según la preferencia del usuario y registramos los cambios de ruta.
  inicializar(): void {
    let consentimientoAnterior: boolean | null = null;

    this.cookieConsent.preferencias.subscribe((preferencias) => {
      if (typeof window.gtag !== 'function') {
        return;
      }

      window.gtag('consent', 'update', {
        analytics_storage: preferencias.analisis ? 'granted' : 'denied',
      });

      // Analytics solo escribe/actualiza _ga cuando envía un hit real (como
      // un page_view), no por el mero cambio de consentimiento. Si se acaba
      // de conceder el permiso (antes no lo tenía), forzamos un page_view
      // para que la cookie se cree en el momento, no solo en la próxima
      // navegación.
      if (preferencias.analisis && consentimientoAnterior !== true) {
        this.enviarVisita(this.router.url);
      }
      consentimientoAnterior = preferencias.analisis;
    });

    this.suscribirCambiosDeRuta();
  }

  private suscribirCambiosDeRuta(): void {
    let esPrimeraNavegacion = true;

    this.router.events
      .pipe(filter((evento) => evento instanceof NavigationEnd))
      .subscribe((evento) => {
        // La primera navegación ya la registra el page_view automático del
        // "config" que se ejecuta en index.html.
        if (esPrimeraNavegacion) {
          esPrimeraNavegacion = false;
          return;
        }
        this.enviarVisita((evento as NavigationEnd).urlAfterRedirects);
      });
  }

  private enviarVisita(ruta: string): void {
    if (typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'page_view', {
      page_path: ruta,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}
